import { render, staticRenderFns } from "./Matrixlike.vue?vue&type=template&id=cd035178&"
import script from "./Matrixlike.vue?vue&type=script&lang=js&"
export * from "./Matrixlike.vue?vue&type=script&lang=js&"
import style0 from "./Matrixlike.vue?vue&type=style&index=0&id=cd035178&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports